import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import { ModalContextProvider, Space } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { QueryClientProvider } from 'react-query'

import { AccountsContextProvider } from '@modules-deprecated/app/accounts'
import { UserOrganizationContextProvider } from '@modules-deprecated/app/organization'
import { InvoicePaymentPane as InvoicePaymentPaneComponent } from '@views/invoices/elements/InvoicePaymentPane'

import { queryClient } from '../../config/queryClient'
import { EmberNavigate, EmberRouterContextProvider } from '../../contexts/emberRouterContext'
import { ThemeProvider } from '../../contexts/themeProvider'
import { HistoryRouter } from '../../utils/HistoryRouter'

const MODULE_NAME = 'invoice-payment-pane-module'

class InvoicePaymentPaneWebComponent extends DOMModel {
  @byAttrVal organizationid: string
  @byAttrVal invoiceid: string
  @registerEvent('navigate') navigate: Function
}

type LockedProps = {
  invoiceid: string
  organizationid: string
  onNavigate: EmberNavigate
}

function InvoicePaymentPane({ invoiceid, organizationid, onNavigate }: LockedProps): ReactElement {
  return (
    <ThemeProvider>
      <EmberRouterContextProvider onNavigate={onNavigate}>
        <QueryClientProvider client={queryClient}>
          <HistoryRouter>
            <ModalContextProvider>
              <UserOrganizationContextProvider organizationId={organizationid}>
                <AccountsContextProvider organizationId={organizationid}>
                  <InvoicePaymentPaneComponent invoiceId={invoiceid} />
                  <Space size="s12" />
                </AccountsContextProvider>
              </UserOrganizationContextProvider>
            </ModalContextProvider>
          </HistoryRouter>
        </QueryClientProvider>
      </EmberRouterContextProvider>
    </ThemeProvider>
  )
}

const InvoicePaymentPaneCustomElement = createCustomElement(
  InvoicePaymentPane,
  InvoicePaymentPaneWebComponent,
  'element',
)

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, InvoicePaymentPaneCustomElement)

export default InvoicePaymentPaneCustomElement
